PJQ.Alert = class {
	constructor($el, options = {}) {
		this.options = _.defaults(options, {
			type: 'primary',
			extraClasses: [],
			text: '',
			isPrepend: false,
			isAppend: false,
			isBefore: false,
			isShowClose: false,
			cookie: null,
			cookieExpirationDays: null,
			style: null,
			animation: null,
			timeout: null
		});
		if (this.options.cookie == null || !PJQ.helpers.cookieHelpers.getCookie(this.options.cookie)){}
			this.createElement($el);
	}

	createElement($el) {
		this.options.isShowClose = this.options.isShowClose || this.options.cookie != null;
		this.$outer = $el;

		this.$el = $('<div>', {
			class: this.options.extraClasses.join(' ') + ' alert alert-' + this.options.type + (this.options.animation != null ? ' hidden' : ''),
			style: this.options.style != null ? this.options.style : ''
		}).html(this.options.text);
		if (this.options.isShowClose) {
			this.$el.append($('<button type="button" class="close alert-item-close text-dark p-1 mr-2 fs-24" data-dismiss="alert" aria-label="Close"><span aria-hidden="true">&times;</span></button>'));
			this.$el.find('.alert-item-close').on('click', _.bind(this.alertClosed, this))
		}
		if (this.options.isAppend)
			this.$outer.append(this.$el);
		else if (this.options.isPrepend)
			this.$outer.prepend(this.$el);
		else if (this.options.isBefore)
			this.$outer.before(this.$el);
		else
			this.$outer.html(this.$el);

		if(this.options.animation != null && _.size(this.options.animation.in) > 0){
			this.$el.animateCSS(this.options.animation.in, function(){
				if(this.options.timeout > 0){
					this.startDestroyTimeout();
				}
			}, this);
		}
		else{
			if(this.options.timeout > 0){
				this.startDestroyTimeout();
			}
		}
	}

	startDestroyTimeout() {
		setTimeout(_.bind(function(){
			this.destroy();
		}, this), this.options.timeout)
	}

	destroy() {
		if(this.options.animation != null && _.size(this.options.animation.out) > 0){
			this.$el.animateCSS(this.options.animation.out, function(){
				this.$el.remove();
			}, this);
		}
		else{
			this.$el.remove();
		}
	}

	alertClosed() {
		if (this.options.cookie != null) {
			PJQ.helpers.cookieHelpers.setCookie(this.options.cookie, true, this.options.cookieExpirationDays);
		}
	}
};